(() => {
  const SECTION_SELECTOR = '.custom-product-comparison-v2';

  function initSection(section) {
    if (
      !section ||
      section.dataset.customProductComparisonV2Initialized === 'true'
    ) {
      return;
    }

    section.dataset.customProductComparisonV2Initialized = 'true';

    if (section.classList.contains('custom-product-comparison-v2--animate')) {
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                section.classList.add('is-visible');
                observer.disconnect();
              }
            });
          },
          { threshold: 0.12 }
        );

        observer.observe(section);
      } else {
        section.classList.add('is-visible');
      }
    } else {
      section.classList.add('is-visible');
    }
  }

  function initAll(scope = document) {
    if (scope.matches && scope.matches(SECTION_SELECTOR)) {
      initSection(scope);
    }

    scope.querySelectorAll?.(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
